import { createStyles } from '@material-ui/core';

export default createStyles({
    dialogRoot: {
        padding: '0.8rem',
    },
});
